import React from 'react'

const Default = React.lazy(() => import('../EyeShadow/Default'))

const data = [
  {
    id: 'Default',
    svg: Default,
    positioning: {
      pointNarrow: {
        y: 100,
        scaleX: 1,
      },
      pointMedium: {
        y: 100,
        scaleX: 1,
      },
      pointWide: {
        y: 100,
        scaleX: 1,
      },
      roundNarrow: {
        y: 100,
        scaleX: 1,
      },
      roundMedium: {
        y: 100,
        scaleX: 1,
      },
      roundWide: {
        y: 100,
        scaleX: 1,
      },
      squareNarrow: {
        y: 100,
        scaleX: 1,
      },
      squareMedium: {
        y: 100,
        scaleX: 1,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
]

export default data
